import React from "react";
import { SxStyleProp } from "theme-ui";
import { Label } from "../Label";
import { Box } from "../Box";

export const sizes = {
  sm: {
    width: "1.375rem",
    height: "0.75rem",
  },
  md: {
    width: "1.875rem",
    height: "1rem",
  },
  lg: {
    width: "2.875rem",
    height: "1.5rem",
  },
};

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  sx?: SxStyleProp;
  checked?: boolean;
  sxWrapper?: SxStyleProp;
  size?: keyof typeof sizes;
  label?: string | React.ReactNode;
}

const Switch: React.FunctionComponent<Props> = React.forwardRef(
  ({ sxWrapper, sx, size = "md" as "md", label, ...restProps }, ref) => (
    <Label
      align="center"
      sx={{ display: "inline-flex", width: "auto", ...(sxWrapper as any) }}
    >
      <Box
        ref={ref}
        as="input"
        type="checkbox"
        {...restProps}
        sx={{
          position: "absolute",
          opacity: 0,
          zIndex: -1,
          width: 1,
          height: 1,
          overflow: "hidden",
        }}
      />
      <Box
        sx={{
          boxSizing: "content-box",
          borderRadius: "full",
          width: sizes[size].width,
          height: sizes[size].height,
          bg: "border",
          p: "2px",
          mr: 2,

          "input:checked ~ &": {
            bg: "primary",

            "> div": {
              transform: `translateX(calc(${sizes[size].width} - ${sizes[size].height}))`,
            },
          },
          "input:focus ~ &": {
            borderColor: "primary",
            outline: "none",
            boxShadow: theme => `0 0 0 2px ${theme.colors.primary}`,
          },
          ...(sx as any),
        }}
      >
        <Box
          aria-hidden="true"
          sx={{
            bg: "white",
            transition: "transform 200ms",
            borderRadius: "full",
            width: sizes[size].height,
            height: sizes[size].height,
          }}
        />
      </Box>
      {label}
    </Label>
  ),
);

Switch.displayName = "Switch";

export default Switch;
